import { countries } from "../constants/countries";
export var getCountry = function getCountry(code) {
  return countries.find(function (_ref) {
    var countryCode = _ref.countryCode;
    return countryCode === code;
  });
};